<template>
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><g clip-path="url(#clip0_225_6389)" stroke="transparent"><circle cx="60" cy="60" r="60" fill="#F2F6FD"></circle><path d="M73.481 91.583H29.277l3.03-3.029a14 14 0 0 1 9.899-4.1h31.275a7.82 7.82 0 0 0 7.843-7.843V55.935h7.13v20.676c0 8.27-6.703 14.972-14.973 14.972ZM35.694 78.037h-7.13V43.793c0-8.259 6.702-14.95 14.973-14.95h38.5l-3.03 3.025a14 14 0 0 1-9.893 4.094H43.537a7.814 7.814 0 0 0-7.843 7.83v34.245Z" fill="#B7C7FF"></path><path d="M62.43 77.324H42.825l5.704-7.13H62.43c1.354 0 2.495-1.14 2.495-2.495 0-1.355-1.14-2.495-2.495-2.495h-3.565c-5.276 0-9.625-4.35-9.625-9.625 0-5.276 4.349-9.625 9.625-9.625h18.893l-5.703 7.13h-13.19c-1.355 0-2.495 1.14-2.495 2.495 0 1.354 1.14 2.495 2.495 2.495h3.565c5.276 0 9.625 4.35 9.625 9.625 0 5.276-4.35 9.625-9.625 9.625ZM89.934 27.131l2.923 7.7a.643.643 0 0 0 .428.428l7.7 2.923c.641.214.641 1.07 0 1.355l-7.7 2.923a.643.643 0 0 0-.428.428l-2.923 7.7c-.214.642-1.07.642-1.355 0l-2.923-7.7a.643.643 0 0 0-.428-.428l-7.7-2.923c-.642-.214-.642-1.07 0-1.355L85.3 35.26a.643.643 0 0 0 .428-.428l2.923-7.7c.214-.57 1.07-.57 1.284 0Z" fill="#B7C7FF"></path></g><defs><clipPath id="clip0_225_6389"><path fill="#fff" d="M0 0h120v120H0z"></path></clipPath></defs></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconDefaultAvatarDarkColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-default-avatar-dark-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
